import React from 'react';
import { Home, Compass, ShoppingCart, MessageCircle, User } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

export const BottomNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // WhatsApp configuration
  
  const WHATSAPP_NUMBER = '9590190213'; // Replace with ANI's actual WhatsApp number (with country code, no + or spaces)
  const WHATSAPP_MESSAGE = 'Hi ANI! I need help with the marketplace.';

  const handleWhatsAppClick = () => {
    const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
    window.open(whatsappUrl, '_blank');
  };

  const navItems = [
    { icon: Home, label: 'Home', path: '/', onClick: () => navigate('/') },
    { icon: Compass, label: 'Explore', path: '/explore', onClick: () => navigate('/explore') },
    { icon: ShoppingCart, label: 'Cart', path: '/cart', onClick: () => navigate('/cart') },
    { icon: MessageCircle, label: 'Help', path: '/whatsapp', onClick: handleWhatsAppClick }, // WhatsApp redirect
    { icon: User, label: 'Profile', path: '/profile', onClick: () => navigate('/profile') },
  ];

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 px-2 py-2 flex justify-around items-center z-50 shadow-lg">
      {navItems.map(({ icon: Icon, label, path, onClick }) => {
        const isActive = location.pathname === path;
        return (
          <button
            key={path}
            onClick={onClick}
            className={`flex flex-col items-center gap-1 p-2 rounded-xl transition-all duration-300 ${
              isActive ? 'bg-primary bg-opacity-10 scale-110' : 'hover:bg-gray-100'
            }`}
          >
            <Icon 
              size={24} 
              className={`transition-colors duration-300 ${
                isActive ? 'text-primary' : 'text-gray-400'
              }`}
            />
            <span className={`text-xs transition-colors duration-300 ${
              isActive ? 'text-primary font-semibold' : 'text-gray-400'
            }`}>
              {label}
            </span>
          </button>
        );
      })}
    </nav>
  );
};